import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import hColor from "@/assets/logo/harbrflow-h-color.png";
import hLight from "@/assets/logo/harbrflow-h-light.png";

/* harbrflow H + wave monogram. Color mark on light, light mark on dark. */
export function LogoMark({ className }) {
    return (
        <span className={cn("relative inline-block", className)}>
            <img
                src={hColor}
                alt=""
                className="block h-full w-full object-contain dark:hidden"
                draggable="false"
            />
            <img
                src={hLight}
                alt=""
                className="hidden h-full w-full object-contain dark:block"
                draggable="false"
            />
        </span>
    );
}

export function Wordmark({ className }) {
    return (
        <span
            className={cn(
                "font-display font-bold uppercase tracking-[0.14em]",
                className,
            )}
        >
            <span className="text-foreground">HARBR</span>
            <span className="text-navy">FLOW</span>
        </span>
    );
}

export function Logo({ to = "/", className, testId = "nav-logo" }) {
    return (
        <Link
            to={to}
            data-testid={testId}
            aria-label="harbrflow home"
            className={cn("flex items-center gap-2.5", className)}
        >
            <LogoMark className="h-8 w-8" />
            <Wordmark className="text-[15px]" />
        </Link>
    );
}
